<template>
  <div class="modal fade" id="modal_nfse_cancellation" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Cancelar NFSe</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Fechar"></button>
        </div>
        <form @submit.prevent="cancel">
          <div class="modal-body">
            <div class="alert alert-warning">
              <i class="bi bi-exclamation-triangle me-2"></i>
              Atenção: O cancelamento de uma NFSe é uma operação irreversível junto ao governo.
            </div>

            <div v-if="nfse" class="mb-4">
              <p class="mb-1"><strong>NFSe:</strong> {{ nfse.nfse_number }}</p>
              <p class="mb-1"><strong>Tomador:</strong> {{ nfse.nfse_taker_name }}</p>
              <p class="mb-0"><strong>Valor:</strong> {{ formatCurrency(nfse.nfse_service_value) }}</p>
            </div>

            <div class="mb-3">
              <label class="form-label required">Motivo do Cancelamento</label>
              <select class="form-select" v-model="form.reason_code" required>
                <option value="">Selecione...</option>
                <option v-for="reason in cancellationReasons" :key="reason.code" :value="reason.code">
                  {{ reason.name }}
                </option>
              </select>
            </div>

            <div class="mb-3">
              <label class="form-label required">Descrição do Motivo</label>
              <textarea class="form-control" v-model="form.reason" rows="3" required
                        minlength="15" placeholder="Descreva o motivo do cancelamento (mín. 15 caracteres)"></textarea>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light" data-bs-dismiss="modal">Fechar</button>
            <button type="submit" class="btn btn-danger" :disabled="cancelling">
              {{ cancelling ? 'Cancelando...' : 'Confirmar Cancelamento' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../../helpers/http";
import Alert from "../../helpers/alert";
import Loader from "../../helpers/loader";

export default {
  name: "ModalNfseCancellation",
  emits: ['cancelled'],
  data() {
    return {
      modal: null,
      nfse: null,
      cancelling: false,
      cancellationReasons: [],
      form: {
        reason_code: '',
        reason: '',
      },
    };
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
  },
  mounted() {
    this.modal = new bootstrap.Modal(document.getElementById('modal_nfse_cancellation'));
    this.loadCancellationReasons();
  },
  methods: {
    async loadCancellationReasons() {
      try {
        const response = await http.get(`/places/${this.place.id_place}/nfse/cancellation-reasons`);
        this.cancellationReasons = response.data;
      } catch (e) {
        console.error('Erro ao carregar motivos:', e);
      }
    },
    open(nfse) {
      this.nfse = nfse;
      this.form = { reason_code: '', reason: '' };
      this.modal.show();
    },
    async cancel() {
      if (!this.form.reason_code || !this.form.reason) {
        Alert.toastError('Preencha todos os campos obrigatórios.');
        return;
      }

      if (this.form.reason.length < 15) {
        Alert.toastError('A descrição do motivo deve ter no mínimo 15 caracteres.');
        return;
      }

      this.cancelling = true;
      Loader.show('Cancelando NFSe', 'Aguarde...');
      try {
        await http.post(`/places/${this.place.id_place}/nfse/${this.nfse.id_nfse}/cancel`, this.form);
        Alert.toastSuccess('NFSe cancelada com sucesso!');
        this.$emit('cancelled');
        this.modal.hide();
      } catch (e) {
        Alert.toastError(e.response?.data?.error || 'Erro ao cancelar NFSe.');
      } finally {
        this.cancelling = false;
        Loader.close();
      }
    },
    formatCurrency(value) {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(value || 0);
    },
  },
};
</script>





